export const channels = {
  SMS: "SMS",
  Voice: "VOICE",
  Email: "EMAIL",
  "Virtual Receptionist": "IVR",
  Bot: "BOT",
  Ip: "IP",
  Ussd: "USSD",
  Mms: "MMS",
  WhatsApp: "WHATSAPP",
};

export const channelConstants = {
  ALL_CHANNEL: "All Channels",
  SMS: "SMS",
  EMAIL: "Email",
  WHATSAPP: "WhatsApp",
  VOICE: "Voice",
  VIRTUAL_RECEPTIONIST: "Virtual Receptionist",
};

export const category = {
  All: "",
  Promotional: 0,
  Transactional: 1,
  OTP: 2,
  Incoming: "inbound",
  Outgoing: "outbound",
  Marketing: 9,
  Utility: 10,
  Authentication: 11,
  Service: 12,
};

export const templateTypeCat = {
  All: "1,2,3",
  Text: 1,
  "Media & Interactive": 2,
  Carousel: 3,
};

export const distributionCat = {
  All: "",
  Authentication: "AUTHENTICATION",
  Marketing: "MARKETING",
  Utility: "UTILITY",
};

export const whatAppBusinessAcctNumStatus = {
  CONNECTED: "CONNECTED",
  PENDING_APPROVAL: "PENDING_APPROVAL",
  PENDING_ISSUE: "PENDING_ISSUE",
};

export const sortFormMonths = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec",
];
// below config for taking full screenshot for documentatino purposes
export const animationEnabled = true; // Set to true to enable animations in charts, false for better performance during development

export const tooltipStyles = {
  upTip: "absolute bottom-5 -left-2 bg-Gallery z-10 rounded-md text-Dove-Gray text-[10px] p-2 whitespace-nowrap",
  downTip: "absolute top-5 -left-2 bg-Gallery z-10 rounded-md text-Dove-Gray text-[10px] p-2 whitespace-nowrap",
  className: "bg-Gallery font-bold z-30 rounded-md text-Dove-Gray text-[10px] p-2 whitespace-nowrap shadow-[0_3px_8px_rgba(0,0,0,0.24)]",
  placement: "top-center",
  iplacement: "top-start"
}
